import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { HttpMethods, SERVICES } from '../../services/api';
import { basicApiAsyncThunkCreator } from '../../services/apiAsyncThunkCreator';
import { showErrorMessage, showSuccessMessage } from '../notifications';
import { ThunkAPI } from '../rootReducer';
import { AccessTypes } from '../../components/common/domain/accountAccessType';
import { selectors as authSelectors } from '../auth';

interface IContactSalesRequester {
  firstName: string;
  lastName: string;
  email: string;
  company: string;
  serviceTier: AccessTypes;
}

export const contactSales: AsyncThunk<void, void, ThunkAPI> = createAsyncThunk(
  '',
  async (_, thunk) => {
    const state = thunk.getState();
    const currentUser = authSelectors.getLoggedInUser(state);
    if (!currentUser) {
      thunk.dispatch(showErrorMessage('There was an error. Please try again later.'));
      return;
    }
    const user: IContactSalesRequester = {
      firstName: currentUser.firstName,
      lastName: currentUser.lastName,
      email: currentUser.email,
      company: currentUser.account.name,
      serviceTier: currentUser.account.accessType
    };
    try {
      const response = await basicApiAsyncThunkCreator<void, IContactSalesRequester>({
        endpoint: 'hubspot/submitUpgradeRequestForm',
        microservice: SERVICES.HUBSPOT_SERVICE,
        authenticated: true,
        method: HttpMethods.Post,
        contentType: 'application/json'
      })(user, thunk);
      thunk.dispatch(showSuccessMessage('Our sales team will contact you shortly about your account upgrade!'));
      return response;
    } catch (err) {
      thunk.dispatch(showErrorMessage('There was an error. Please try again later.'));
      return thunk.rejectWithValue(err);
    }
  }
);